import Client from "../AxiosClient";
const resource = "/private/timekeepings/";

export default {
  async get_timekeeping(params) {
    try {
      const response = await Client.get(
        `${resource}get_timekeeping?year=${params.year}&month=${params.month}&employee_id=${params.employee_id}&status=${params.status}&id=${params.id}&department_id=${params.department_id}`
      );

      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error.message,
      };
    }
  },

  async get_office_summary_tk(params) {
    try {
      const response = await Client.get(
        `${resource}get_office_summary_tk?year=${params.year}&month=${params.month}&employee_id=${params.employee_id}&status=${params.status}&id=${params.id}&department_id=${params.department_id}`
      );
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error.message,
      };
    }
  },

  async report_office_summary_tk(params) {
    try {
      const response = await Client.get(`${resource}report_office_summary_tk`, {
        headers: {
          "Access-Control-Expose-Headers": "Content-Disposition",
        },
        responseType: "blob",
        params: params,
      });

      return response;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error.message,
      };
    }
  },

  async get_type_timekeeping(params) {
    // console.log("getTarget");
    try {
      const response = await Client.get(
        `${resource}get_type_timekeeping?type=${params.type}`
      );

      // console.log(response);
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error.message,
      };
    }
  },

  async statistical_timekeeping(params) {
    // console.log("getTarget");
    try {
      const response = await Client.get(
        `${resource}statistical_timekeeping?type=${params.type}&sub_type=${params.sub_type}&year=${params.year}&department_id=${params.department_id}`
      );

      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error.message,
      };
    }
  },

  async update_timekeeping(body) {
    // console.log("getTarget");
    try {
      const response = await Client.post(`${resource}update_timekeeping`, body);
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error.message,
      };
    }
  },

  /**
   * Cập nhật trạng thái ngày công của nhiều ngày cùng lúc.
   * @param {} data
   * @returns
   */
  async updateMultipleDayInTimeSheet(data) {
    try {
      const response = await Client.post(
        `${resource}update_timekeeping_multiple`,
        {
          timekeepingcode_arr: data,
        }
      );
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error.message,
      };
    }
  },

  async censorship_timekeeping(body) {
    // console.log("getTarget");
    try {
      const response = await Client.post(
        `${resource}censorship_timekeeping`,
        body
      );
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error.message,
      };
    }
  },

  async censorship_timekeeping_department(body) {
    try {
      const response = await Client.post(
        `${resource}censorship_timekeeping_department`,
        body
      );
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error.message,
      };
    }
  },
  async lock_timekeeping(body) {
    try {
      const response = await Client.post(`${resource}lock_timekeeping`, body);
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error.message,
      };
    }
  },

  //#region HOLIDAY
  async get_holiday(params) {
    try {
      const response = await Client.get(
        `${resource}get_holiday?year=${params.year}`
      );

      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error.message,
      };
    }
  },

  async delete_holiday(body) {
    try {
      const response = await Client.post(`${resource}delete_holiday`, body);
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error.message,
      };
    }
  },

  async add_holiday(body) {
    try {
      const response = await Client.post(`${resource}create_holiday`, body);
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error.message,
      };
    }
  },

  async downloadReport(params) {
    try {
      const response = await Client.get(`${resource}report`, {
        headers: {
          "Access-Control-Expose-Headers": "Content-Disposition",
        },
        responseType: "blob",
        params: params,
      });

      return response;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },

  //#endregion
};
